import { MaintenanceWindowsAppController } from '../controller/MaintenanceWindowsAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MaintenanceWindowsAppWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowsAppController,
    });
  }

  private observablePropertyHandler = {
    "data-company-id": this.companyIdChanged.bind(this),
  };

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-company-id"];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (this.observablePropertyHandler[name]) {
      this.observablePropertyHandler[name](oldValue, newValue);
    } else if (MaintenanceWindowsAppWebComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as MaintenanceWindowsAppController)?.render().then().catch();
    }
  }

  private companyIdChanged() {
    (this.controller as MaintenanceWindowsAppController)?.render();
    (this.controller as MaintenanceWindowsAppController)?.triggerGridReload();
  }

}
